export default __webpack_public_path__ + "static/media/arrow-top-right.b4941b3f.svg";